import i18n from "@/i18n"; // 引入 I18n 套件

const knowFroms = ['facebook', 'instagram', 'wechat', 'rednote', 'website', 'referral', 'other'];
export const main = {
    install(Vue, option) {
        i18n.init(option.config).then(oI18n => {
            // **************** 如何認識我們
            const knowFromOptions = knowFroms.map(key => {
                return { value: key, text: oI18n.t(`knownFromOptions.${key}`) };
            });
            Vue.prototype.$knowFromOptions = knowFromOptions;

            // **************** 地區
            const regions = ['hk', 'kl', 'nt', 'islands'];
            const regionOptions = regions.map(key => {
                return { value: key, text: oI18n.t(`regionOption.${key}`) };
            });
            Vue.prototype.$regionOptions = regionOptions;
        })
    }
}

export const knowFromList = knowFroms;
export const excludeMenuList = ['requirement', 'student-requirement', 'online-course', 'notify', 'video', 'website-setting', 'setting-requirement', 'enquiry'];
